import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Thank You`}</h2>
    <p>{`Email: info`}{`[at]`}{`jcgaming.ir`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      